export const CMS_DATA_REQUESTED = 'home/CMS_DATA_REQUESTED'
